/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from "react";
import { IoCopyOutline } from 'react-icons/io5'
import Mail from "../mail";
import {
  Row,
  Col,
  Dropdown,
  List,
  Typography,
  Space,
  Button,
  Popover,
  Breadcrumb,
  Input,
  message,
  Modal,
  Tooltip,
  Spin,
  theme
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { BsChevronDown } from "react-icons/bs";
import {
  BellOutlined,
  MenuOutlined,
  MailOutlined,
} from "@ant-design/icons";
import {
  Link,
  useNavigate,
  useParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UserInfo from "../userInfo";
import useFetch from "../../_fetch";
import { logout } from "../../store/action/user";
import { user_role } from "../../consts";
import Activity from "../activity/index";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";
import SearchBox from "../SearchBox";
import PermissionModal from "../PermissionModal";
import SendMail from "../../pages/sendMailModal";
import { useDeleteCompany, useGetAllCompanies, useGetAllPrimaryClientsUsers } from "../../utils/queryUtils";
import { setSelectedClient, setSelectedCompany, setSelectedPrimaryClient } from "../../store/action/selected";
import axios from "axios";
import { useQueryClient } from "@tanstack/react-query";
import { FiRefreshCcw } from "react-icons/fi";
import { trackEvent } from "../../utils/mixpanel";
import { normalizeString } from "../../utils/pathUtils";




function BreadCrumbComponent() {

  const path = window.location.pathname
    .split("/")
    .filter((elem) => elem !== "");

  const { companyName, clientName, fy, queryId, folderId } = useParams();

  useEffect(() => { }, [companyName, clientName, fy, queryId, folderId, path]);
  const currentTab = new URLSearchParams(window.location.search).get("tab");
  const breadcrumbItems = path.map((item, index) => {
    const isLast = index === path.length - 1;
    const linkPath = `/${path.slice(0, index + 1).join("/")}${isLast && currentTab ? `?tab=${currentTab}` : ""}`;
    return {
      key: `breadcrumb-${item}-${index}`,
      title: <Link to={linkPath}>{decodeURIComponent(item)}</Link>,
    };
  });

  return <Breadcrumb items={breadcrumbItems} />;
}



function Header({ onPress }) {
  const dispatch = useDispatch();
  const { Title } = Typography;
  const { _id, role, first_name, last_name, email, company_ids = [] } = useSelector(
    (st) => st.user
  );

  const { company } = useSelector((st) => st.selected)
  const { name: selectedCompany, _id: selectedCompanyId } = company;

  const queryClient = useQueryClient();

  const { data } = useGetAllCompanies(_id);
  const all = data;

  useEffect(() => {
    if (all && all.length > 0) {
      if (!selectedCompany) {
        dispatch(setSelectedCompany(all[0]));
      }
    }
  }, [all, selectedCompany, dispatch]);
  const { token: { colorPrimary } } = theme.useToken();
  const [firmsToShow, setFirmsToShow] = useState([]);
  const [showInboxPopover, setShowInboxPopover] = useState(false);
  const [showSendMailModal, setShowSendMailModal] = useState(false);
  const [showFirmDropdown, setShowFirmDropdown] = useState(false);
  const [permissionModalOpen, setPermissionModalOpen] = useState(null);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const allPrimaryClients = useGetAllPrimaryClientsUsers(selectedCompanyId);
  const [editFirmTitle, setEditFirmTitle] = useState("");
  const selectedPrimaryClient = useSelector((st) => st.selected.primaryClient);
  const [editedText, setEditedText] = useState("");
  const [isRefetching, setIsRefetching] = useState(false);
  const [clientsToShow, setClientsToShow] = useState([]);
  const [primaryClients, setPrimaryClients] = useState([]);

  const navigate = useNavigate();
  const _fetch = useFetch();
  const breakpoint = useBreakpoint();

  const { mutateAsync: delete_Company, isSuccess: isDeleteSuccess } = useDeleteCompany()

  const copyDomain = async (domain) => {
    navigator.clipboard.writeText(domain);
    message.success("Invite Link Copied To Clipboard");
  }

useEffect(() => {
  window.scrollTo(0, 0);
}, []);
  useEffect(() => {
    if (role === user_role.ACCOUNTANT) {
      let data = all?.filter(key => {
        return company_ids?.includes(key?._id)
      })
      setFirmsToShow(data)
    }
    else if (all?.length) setFirmsToShow(all);
  }, [showFirmDropdown]);

  async function _logout() {
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/user/logout`, {}, {
        withCredentials: true,
      });
      trackEvent("Logout", {
        "_id": _id,
        "Email": email,
        "First Name": first_name,
        "Last Name": last_name,
        "Role": role
      })
      // localStorage.clear('TANSTACK_QUERY_CACHE')
      localStorage.removeItem("persist:auslink-redux");
      localStorage.clear();
      dispatch(logout());
      dispatch(setSelectedCompany({}));
      dispatch(setSelectedClient({}));
      dispatch(setSelectedPrimaryClient({}));
      queryClient.removeQueries();
      navigate("/auth/sign-in", { replace: true });
    } catch (err) {
      console.error(err);
    }
  }

  useEffect(() => {
    for (var i = 0; i < all?.length; i++) {
      all[i].title = `${all[i].name}`;
    }
  }, [all]);

  useEffect(() => {
    setPrimaryClients([]);
    setClientsToShow([]);
    if (selectedCompanyId && allPrimaryClients?.refetch) {
      allPrimaryClients.refetch();
    }
  }, [selectedCompanyId]);


  useEffect(() => {
    if (allPrimaryClients?.data !== undefined) {
      const filteredClients = allPrimaryClients.data.filter(
        user => user?.role === user_role.PRIMARY_CLIENT
      );
      setPrimaryClients(filteredClients);
    }
  }, [allPrimaryClients?.data]);


  // Also update the clientsToShow useEffect:
  useEffect(() => {
    // Set clients to show when dropdown opens
    if (showClientDropdown && primaryClients.length > 0) {
      setClientsToShow(primaryClients);
    }
  }, [showClientDropdown, primaryClients]);

  async function deleteCompany() {

    try {

      let res = await delete_Company(permissionModalOpen._id)
      if (permissionModalOpen._id === selectedCompanyId) {
        if (permissionModalOpen !== all[0]) {
          navigate(`/${normalizeString(all[0]?.name)}`, { replace: true })
        } else {
          navigate(`/${normalizeString(all[1]?.name)}`, { replace: true })
        }
        // navigate(`/`, {replace:true})
      }
      if (res.success || isDeleteSuccess) {
        message.success(`Australian Firm deleted successfully`);
      } else {
        message.error("Error deleting company");
      }
    } catch (err) {
      message.error("Something went wrong");
      console.error(err);
    } finally {
      setPermissionModalOpen(null);
    }



    // try {
    //   let res = await _fetch(`${process.env.REACT_APP_API_URL}/company`, {
    //     method: "DELETE",
    //     body: {
    //       id: permissionModalOpen._id,
    //       user_id: _id,
    //     },
    //   });
    //   res = await res.json();
    //   if (res.status === 200) {
    //     // setCookie("userInfo", {
    //     //   ...cookie.userInfo,
    //     //   selectedCompany:
    //     //     selectedCompany._id === permissionModalOpen._id
    //     //       ? null
    //     //       : selectedCompany,
    //     // });

    //     // await getCompanies();
    //     // dispatch(changeSelectedCompany(all[0]))
    //     navigate("/", { replace: true });
    //     message.success(`Australian Firm deleted successfully`);
    //   } else {
    //     message.error(res.response);
    //   }
    // } catch (err) {
    //   message.error("Something went wrong");
    //   console.log(err);
    // } finally {
    //   setPermissionModalOpen(null);
    // }
  }

              const clientMenu = (
    <List
      className="header-clients-dropdown"
      style={{
        maxHeight: "70vh",
        minWidth: "18vw",
        overflow: "auto",
        backgroundColor: "white",
        padding: "0px 10px",
        borderRadius: "10px",
        boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.15)",
      }}
      itemLayout="horizontal"
      dataSource={clientsToShow}
      renderItem={(item) => (
        <List.Item >
          <div style={{ width: "100%" }} >
            <List.Item.Meta
              title={
                <div style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                  <Typography>{item.first_name} {item.last_name}</Typography>
                </div>
              }
              onClick={() => {
                setShowClientDropdown(false);
                try {
                  dispatch(setSelectedPrimaryClient(item));
                } catch (e) {
                  console.error('Failed to set selected primary client', e);
                }
                navigate(`/${normalizeString(selectedCompany)}/${item._id}`, { replace: true });
              }}
            />
          </div>
        </List.Item>
      )}
      locale={{
        emptyText: allPrimaryClients.isLoading ?
          <Spin size="small" /> :
          "No clients available"
      }}

    />
  );

  const menu = (

    <List
      className="header-companies-dropdown"
      style={{
        maxHeight: "70vh",
        minWidth: "18vw",
        overflow: "auto",
        backgroundColor: "white",
        padding: "0px 10px",
        borderRadius: "10px",
        boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.15)",
      }}
      itemLayout="horizontal"
      dataSource={firmsToShow}
      header={
        <div className="input_box1">
          <SearchBox all={all} setshow={setFirmsToShow} className="move1" />
        </div>
      }
      renderItem={(item) => (
        <List.Item >

          <div style={{ width: "100%" }} >
            <List.Item.Meta
              title={
                <div style={{ cursor: "pointer", display: "flex", justifyContent: "space-between", alignItems: "center" }} >
                  <Typography>{item.name}</Typography>
                  {role === user_role.ADMIN && (
                    <div>
                      <Button
                        type="link"
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowFirmDropdown(false);
                          setPermissionModalOpen(item);
                        }}
                      >
                        <DeleteOutlined
                          style={{
                            color: "red",
                            fontSize: "15px",
                          }}
                        />
                      </Button>
                    </div>
                  )}
                </div>
              }
              onClick={() => {
                setShowFirmDropdown(false);
                // dispatch(changeSelectedFY({}));
                // dispatch(changeSelectedClient({}));
                // setCookie("userInfo", {
                //   ...cookie.userInfo,
                //   selectedCompany: item,
                // });
                dispatch(setSelectedCompany(item));
                navigate(`/${normalizeString(item?.name)}`, { replace: true });
              }}
            />
            {/* <List.Item.Meta
            title={
              <div>
                <IoCopyOutline />
                {`${process.env.REACT_APP_HOME}/invite/${item?.domain}`}
              </div>
            }
            onClick={() =>
              copyDomain(`${process.env.REACT_APP_HOME}/invite/${item?.domain}`)
            }
          /> */}
            {item.domain ? <div
              style={{ display: "flex", cursor: "pointer", justifyContent: "center", alignItems: "center", padding: "0.4rem" }}
              onClick={() =>
                copyDomain(
                  `${process.env.REACT_APP_HOME}/invite/${item?.domain}`
                )
              }
            >
              <IoCopyOutline />
              <Typography.Text
                code={true}
                ellipsis={true}
              >
                {`${process.env.REACT_APP_HOME}/invite/${item?.domain}`}
              </Typography.Text>

            </div> : <></>}

          </div>

        </List.Item>
      )}
    />
  );

  const postNewFirmName = async () => {
    try {
      let res = await _fetch(`${process.env.REACT_APP_API_URL}/company`, {
        method: "PATCH",
        body: {
          id: editFirmTitle._id,
          name: editedText,
        },
      });
      res = await res.json();
      if (res.status >= 200 && res.status < 300) {
        setEditFirmTitle("");
        setEditedText("");
        // dispatch(getAllCompanies());
      } else message.error(res.response);
    } catch (e) {
      console.error(e);
      message.error(e.message);
    }
  };

  const accountMenu = (
    <List
      className="header-companies-dropdown"
      itemLayout="horizontal"
      style={{
        maxHeight: "70vh",
        overflow: "auto",
        backgroundColor: "white",
        paddingLeft: 14,
        paddingRight: 10,
        borderRadius: "10px",
        boxShadow: "0px 0px 20px 0px rgba(0,0,0,0.15)",
        cursor: 'pointer'
      }}
    >
      <List.Item
        className="pointer"
        onClick={() => navigate("/auth/change-password", { replace: true })}
      >
        <List.Item.Meta title="Change Password" />
      </List.Item>
      <List.Item className="pointer" onClick={() => _logout()}>
        <List.Item.Meta title="Logout" />
      </List.Item>
    </List>
  );

  useEffect(() => {
    // getCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  const openSendMailModal = () => {
    setShowInboxPopover(false);
    setShowSendMailModal(true);
  };
  const refetchQueries = async () => {
    setIsRefetching(true);
    await queryClient.refetchQueries();
    setIsRefetching(false);
    message.success("Data fetched successfully")
  };

  return (
    <>
      <Row style={{ justifyContent: "space-between" }} gutter={[5, 0]}>
        {!breakpoint.lg && (
          <Col md={6}>
            <Button
              type="link"
              className="sidebar-toggler"
              onClick={() => onPress()}
            >
              <MenuOutlined style={{ fontSize: "20px" }} />
            </Button>
          </Col>
        )}
        <Col
          lg={12}
          xs={24}
        >
          <BreadCrumbComponent />
        </Col>

        <Col lg={12} sm={24}>
          <div className="d-flex justify-content-end align-items-center">
            <Space>


              <Popover
                open={isRefetching}
                trigger="click"
                // content={
                //   <Spin size="small" />
                // }
                destroyTooltipOnHide
              >
                <Tooltip title="Refetch Data" color="rgb(0 0 0 / 44%)" fontSize="small">
                  <Button
                    onClick={() => refetchQueries()}
                    style={{
                      borderRadius: "10px",
                      // borderColor: "transparent",
                      // backgroundImage: "linear-gradient(#000, #000)",
                      // boxShadow: "0 0 10px #000",
                    }}
                    type="link"
                    icon={<FiRefreshCcw size={20} color={colorPrimary} style={{ animation: isRefetching ? 'spin 0.7s linear infinite' : 'none' }} />}
                    size="large"
                  />
                </Tooltip>
              </Popover>

              <Popover
                onOpenChange={(e) => {
                  if (!e) {
                    setShowInboxPopover(false);
                  }
                }}
                open={showInboxPopover}
                trigger="click"
                content={
                  <div style={{ height: "500px", width: "400px" }}>
                    <Mail
                      setShowInboxPopover={setShowInboxPopover}
                      canNavigate={true}
                      openSendMailModal={openSendMailModal}
                      height={500}
                      width={400}
                    />
                  </div>
                }
                destroyTooltipOnHide
              >
                <Tooltip title="Mail" color="rgb(0 0 0 / 44%)" fontSize="small">
                  <Button
                    onClick={() => setShowInboxPopover(true)}
                    style={{
                      borderRadius: "10px",
                      borderColor: "transparent",
                      backgroundImage: "linear-gradient(#4CB8C4, #3CD3AD)",
                      boxShadow: "0 0 10px #4CB8C4",
                    }}
                    type="primary"
                    icon={<MailOutlined />}
                    size="large"
                  />
                </Tooltip>
              </Popover>

              {/** Notification bell temporarily disabled
              <Popover
                trigger="click"
                content={
                  <div
                    style={{
                      height: "500px",
                      width: "400px",
                      overflow: "auto",
                    }}
                    id="scrollableDiv"
                  >
                    <Activity canNavigate={true} />
                  </div>
                }
                destroyTooltipOnHide
              >
                <Tooltip
                  title="Notification"
                  color="rgb(0 0 0 / 44%)"
                  fontSize="small"
                >
                  <Button
                    style={{ borderRadius: "10px" }}
                    type="primary"
                    icon={<BellOutlined />}
                    size="large"
                  />
                </Tooltip>
              </Popover>
              */}
              {role !== user_role.PRIMARY_CLIENT && <Dropdown
                overlay={clientMenu}
                trigger={["click"]}
                onOpenChange={() => {
                  setShowClientDropdown(!showClientDropdown);
                }}
                destroyPopupOnHide={true}
                open={showClientDropdown}
              >
                <Button
                  className="my-auto"
                  style={{
                    minWidth: "150px",
                    backgroundColor: "#fad02c",
                    borderColor: "#fad02c",
                  }}
                >
                  <div className="d-flex justify-content-between">
                    <Title level={4} className="my-auto text-white mx-1">
                      {(selectedPrimaryClient
                        ? `${selectedPrimaryClient.first_name ?? ""} ${selectedPrimaryClient.last_name ?? ""}`.trim()
                        : null) || "Select Client"}
                    </Title>
                    <BsChevronDown size={20} className="my-auto" color="#fff" />
                  </div>
                </Button>
              </Dropdown>}

              {role !== user_role.STAFF && role !== user_role.PRIMARY_CLIENT && !selectedPrimaryClient?._id ? (
                <Dropdown
                  overlay={menu}
                  trigger={["click"]}
                  onOpenChange={() => {
                    if (showFirmDropdown === true) {
                      setShowFirmDropdown(false);
                    }
                    else {
                      setShowFirmDropdown(true);
                    }

                  }}
                  destroyPopupOnHide={true}
                  open={showFirmDropdown}
                >
                  <Button
                    className="my-auto"
                    style={{ minWidth: "150px" }}
                    type="primary"
                  >
                    <div className="d-flex justify-content-between">
                      <Title level={4} className="my-auto text-white mx-1">
                        {selectedCompany}
                      </Title>
                      <BsChevronDown size={20} className="my-auto" />
                    </div>
                  </Button>
                </Dropdown>
              ) : (
                role === user_role.STAFF ? null : (
                  <Button
                    className="my-auto"
                    style={{ minWidth: "150px" }}
                    type="primary"
                  >
                    <div className="d-flex justify-content-between">
                      <Title level={4} className="my-auto text-white mx-1">
                        {selectedCompany}
                      </Title>
                    </div>
                  </Button>
                )
              )}

              <Dropdown overlay={accountMenu} trigger={["click"]}>
                <div className="pointer d-flex items-center cursor-pointer">
                  <UserInfo
                    firstName={first_name}
                    lastName={last_name}
                    email={email}
                    avatraProps={{
                      size: "large",
                      style: { backgroundColor: colorPrimary, cursor: 'pointer' },
                    }}
                  />
                </div>
              </Dropdown>
            </Space>
          </div>
        </Col>
      </Row>
      <PermissionModal
        visible={permissionModalOpen !== null}
        setVisible={setPermissionModalOpen}
        onSuccess={deleteCompany}
        child={
          <p>
            Are you sure you want to delete this <b>Australian Firm</b>? This
            will delete all the <b>Entities</b>, <b>Financial Years</b>,{" "}
            <b>Queries</b>, and <b>Attachments</b> related to this Australian
            Firm.
          </p>
        }
      />
      <SendMail show={showSendMailModal} setShow={setShowSendMailModal} />
      <Modal
        open={!!editFirmTitle}
        onCancel={() => setEditFirmTitle(false)}
        title="Edit Australian Firm"
        centered
        onOk={postNewFirmName}
        destroyOnClose
      >
        <Input
          defaultValue={editFirmTitle.name}
          onChange={(e) => setEditedText(e.target.value)}
        />
      </Modal>
    </>
  );
}

export default Header;
